import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { Unit5RoutingModule } from './unit-5-routing.module';


@NgModule({
  imports: [CommonModule, ReactiveFormsModule, Unit5RoutingModule],
  declarations: [Unit5RoutingModule.components]
})

export class Unit5Module { }
